import { memo } from "react";
import SectionSkeleton from "../SectionSkeleton";
import ItemCommunity from "./ItemCommunity";
import MainNodata from "../NodataComponent";
import { _t } from "core/language";

interface TrendingComponentProps {
  data: any;
  loading: boolean;
  border?: boolean;
  tab?: string;
}

const TrendingComponent = ({ data, loading, border, tab }: TrendingComponentProps) => {
  const hasData = data?.length > 0;
  return (
    <div className="w-full">
      <div className="grid grid-cols-2 gap-x-2">
        {loading && !hasData && <SectionSkeleton width={140} height={140} />}
        {data?.map((item: any, index: number) => (
          <ItemCommunity community={item} border={border} key={index} tab={tab} />
        ))}
      </div>
      <MainNodata
        loading={loading}
        data={data}
        text={_t("main.community.no_data")}
      />
    </div>
  );
};

export default memo(TrendingComponent);
